import { PropsWithChildren } from 'react';
import { ScreenCardContent } from './ScreenCardContent';
import { ScreenCardHeader } from './ScreenCardHeader';
import { ScreenCardWrapper } from './ScreenCardWrapper';

interface IScreenCardProps extends PropsWithChildren {
  title?: string;
  backBtn?: {
    to: string;
    label: string;
  };
}

export const ScreenCard = ({
  title,
  backBtn,
  children,
}: IScreenCardProps): JSX.Element => {
  return (
    <ScreenCardWrapper>
      <ScreenCardHeader title={title} backBtn={backBtn} />

      <ScreenCardContent title={title}>{children}</ScreenCardContent>
    </ScreenCardWrapper>
  );
};
